module.exports = __webpack_public_path__ + "img/01.3465a6f5.png";